import {request} from './online-api.js';

// Fahrer-Vertrag vom 07.10.2026: Fragment-Zugang, Header-Authentisierung,
// PREPARING oder READY -> OUT_FOR_DELIVERY -> HANDED_OVER. Kein Shop-/Kundenzahlungszugang.
const sessionKey = 'zalso-driver-session';
const attemptKey = (orderId, state) => `zalso-driver-attempt:${orderId}:${state}`;
const validId = value => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value || '');
const validSession = value => validId(value?.orderId) && typeof value.token === 'string' &&
  value.token.length > 0 && !/[\s\x00-\x1f\x7f]/.test(value.token);
export const driverStates = [null,'ACCEPTED','PREPARING','READY','OUT_FOR_DELIVERY','HANDED_OVER'];

export function driverSession(demo) {
  const fragment = location.hash;
  // Vor Requests und auch bei gesperrtem Speicher entfernen; Query-Zugänge nie akzeptieren.
  if (fragment || location.search) history.replaceState(null, '', location.pathname);
  if (demo) return null;
  if (fragment) {
    sessionStorage.removeItem(sessionKey);
    const parts = new URLSearchParams(fragment.slice(1));
    const value = {orderId:parts.get('o'),token:parts.get('t')};
    if (parts.getAll('o').length !== 1 || parts.getAll('t').length !== 1 || !validSession(value)) return null;
    sessionStorage.setItem(sessionKey,JSON.stringify(value));
  }
  const stored = JSON.parse(sessionStorage.getItem(sessionKey) || 'null');
  return validSession(stored) ? stored : null;
}

export function markDriverLoaded(session) {
  session.loaded = true;
  sessionStorage.setItem(sessionKey,JSON.stringify(session));
}

export function driverAttempt(orderId,state) {
  const key = attemptKey(orderId,state);
  const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
  if (stored) {
    if (!validId(stored.key) || !Number.isFinite(stored.retryAt)) throw Error('invalidAttempt');
    return stored;
  }
  const attempt = {key:crypto.randomUUID(),retryAt:0};
  sessionStorage.setItem(key,JSON.stringify(attempt));
  return attempt;
}
export function deferDriverAttempt(orderId,state,attempt,retryAt) {
  attempt.retryAt = retryAt;
  sessionStorage.setItem(attemptKey(orderId,state),JSON.stringify(attempt));
}
export function finishDriverAttempt(orderId,state) {
  sessionStorage.removeItem(attemptKey(orderId,state));
}
export function driverRequest(session,signal,state,attempt) {
  return request(`/delivery/${encodeURIComponent(session.orderId)}${state?'/status':''}`,{
    signal,redirect:'error',method:state?'POST':'GET',
    headers:{'X-Driver-Token':session.token,...(state?{'Content-Type':'application/json','Idempotency-Key':attempt.key}:{})},
    ...(state?{body:JSON.stringify({state})}:{})
  });
}
export function validateDriverResponse(data,orderId,target) {
  if (!data || data.orderId !== orderId || data.orderNo == null || !driverStates.includes(data.kitchenState) ||
      (target && data.kitchenState !== target) || (!target && (!data.customer || !Array.isArray(data.items)))) {
    throw Error('invalidDriverResponse');
  }
  return data;
}

// STARTWERT: feste Vorschau-Lieferung ohne Backend-Aufruf.
export const demoDelivery = {
  orderId:'20000000-0000-4000-8000-000000000001',orderNo:'123',kitchenState:'READY',
  requestedFor:'2026-10-08T18:30:00+02:00',expectedAt:null,stateChangedAt:null,linkExpiresAt:null,
  customer:{firstName:'Alex',lastName:'Gast',phone:'+49301234567'},
  address:{street:'Musterstraße 12',postalCode:'10115',city:'Berlin',note:'Bitte klingeln'},
  items:[{name:'Suppe',quantity:2,variant:'Groß'},{name:'Brot',quantity:1,variant:null}]
};
